// tslint:disable
/**
 * Property Management
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { GetGuestNoteTypesResponse } from '../models';
import { ProblemDetails } from '../models';
/**
 * GuestNoteTypesApi - axios parameter creator
 * @export
 */
export const GuestNoteTypesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGuestnotetypesGet(propertyId: string, options: any = {}): RequestArgs {
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling propertyIdGuestnotetypesGet.'
        );
      }
      const localVarPath = `/{propertyId}/guestnotetypes`.replace(
        `{${'propertyId'}}`,
        encodeURIComponent(String(propertyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GuestNoteTypesApi - functional programming interface
 * @export
 */
export const GuestNoteTypesApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGuestnotetypesGet(
      propertyId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGuestNoteTypesResponse> {
      const localVarAxiosArgs = GuestNoteTypesApiAxiosParamCreator(
        configuration
      ).propertyIdGuestnotetypesGet(propertyId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * GuestNoteTypesApi - factory interface
 * @export
 */
export const GuestNoteTypesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGuestnotetypesGet(
      propertyId: string,
      options?: any
    ): AxiosPromise<GetGuestNoteTypesResponse> {
      return GuestNoteTypesApiFp(configuration).propertyIdGuestnotetypesGet(propertyId, options)(
        axios,
        basePath
      );
    },
  };
};

/**
 * GuestNoteTypesApi - object-oriented interface
 * @export
 * @class GuestNoteTypesApi
 * @extends {BaseAPI}
 */
export class GuestNoteTypesApi extends BaseAPI {
  /**
   *
   * @param {string} propertyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GuestNoteTypesApi
   */
  public propertyIdGuestnotetypesGet(propertyId: string, options?: any) {
    return GuestNoteTypesApiFp(this.configuration).propertyIdGuestnotetypesGet(propertyId, options)(
      this.axios,
      this.basePath
    );
  }
}
